const imported = {};

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {

	const { config } = mpro;

	// Add facebook handling
	if (config?.facebook?.enabled) {
		// Has side-effects
		if (!imported.fb) {
			imported.fb = true;
			import('./mpro.fb.js').then(({ fbInitializeLib }) => fbInitializeLib());
		}
	}

	// Add google handling
	if (config?.google_login?.enabled) {
		import('./mpro.google.js').then(({ googleInitializeLib }) => googleInitializeLib().then((google) => {
			for (const elem of document.querySelectorAll('.g_id_signin')) {
				google.accounts.id.renderButton(elem, {
					width: elem.offsetWidth,
					locale: elem.dataset?.locale,
					logo_alignment: elem.dataset?.logo_alignment,
					shape: elem.dataset?.shape,
					size: elem.dataset?.size,
					text: elem.dataset?.text,
					theme: elem.dataset?.theme,
					type: elem.dataset?.type,
				});
			}
		}));
	}

	// Enable ajax navigation
	if (config.shop.ajax_navigation.enabled) {
		// Has side-effects
		if (!imported.ajaxNavigation) {
			imported.ajaxNavigation = true;
			import('./mpro.ajaxify.js');
		}
	}

	// Fancybox gallery
	if ($container.find('[data-fancybox]').length > 0) {
		// Has side-effects
		if (!imported.fancybox) {
			imported.fancybox = true;
			import('./mpro.fancybox.js');
		}
	}

	// Custom date-picker
	/** @type {JQuery<HTMLInputElement>} */
	// @ts-ignore
	const $dateInputs = $container.find('input[data-date-picker]');
	if ($dateInputs.length > 0) {
		import('./mpro.date-picker.js').then(({ enhanceInputs }) => enhanceInputs($dateInputs));
	}

	// New date-picker (easepicker with range)
	/** @type {JQuery<HTMLInputElement>} */
	// @ts-ignore
	const $dateInputs2 = $container.find('input[data-drp]');
	if ($dateInputs2.length > 0) {
		import('./date-range-picker/index.js').then(({ enhanceElements }) => enhanceElements($dateInputs2));
	}

	// Custom selects (select2)
	/** @type {JQuery<HTMLSelectElement>} */
	// @ts-ignore
	const $customSelects = $container.find('select[data-custom-select]');
	if ($customSelects.length > 0) {
		import('./mpro.select2.js').then(({ enhanceSelects }) => enhanceSelects($customSelects));
	}

	// Google Maps Api
	/** @type {JQuery<HTMLElement>} */
	// @ts-ignore
	const $gMapsContainers = $container.find('div[data-google-maps-init], section[data-google-maps-init], span[data-google-maps-init]');
	if ($gMapsContainers.length > 0) {
		import('./gmaps/pickup-delivery-markers.js').then(({ init }) => init($gMapsContainers));
	}

	// Leaflet OpenStreetMaps Api
	/** @type {JQuery<HTMLElement>} */
	// @ts-ignore
	const $osMapsContainers = $container.find('div[data-los-maps-init], section[data-los-maps-init], span[data-los-maps-init]');
	if ($osMapsContainers.length > 0) {
		import('./leaflet/pickup-delivery-markers.js').then(({ init }) => init($osMapsContainers));
	}

	// File upload fields
	const $simpleUploaders = $container.find('div[data-file-upload]');
	if ($simpleUploaders.length > 0) {
		import('./mpro.file-upload-simple.js').then(({ initFileUploadDecorator }) => initFileUploadDecorator($simpleUploaders));
	}

	// Find ajax-upload elements
	/** @type {JQuery<HTMLInputElement>} */
	// @ts-ignore
	const $ajaxUploadInputs = $container.find('input[type="file"][data-ajax-upload]');
	if ($ajaxUploadInputs.length > 0) {
		import('./mpro.file-upload.js').then(({ initAjaxUploadDecorator }) => initAjaxUploadDecorator($ajaxUploadInputs));
	}

	// International phone input
	/** @type {JQuery<HTMLInputElement>} */
	// @ts-ignore
	const $intlPhoneInputs = $container.find('input[data-intl-phone]');
	if ($intlPhoneInputs.length > 0) {
		import('./mpro.intl-phone.js').then(({ initIntlPhoneDecorator }) => initIntlPhoneDecorator($intlPhoneInputs));
	}

	// Overlay highlight
	/** @type {JQuery<HTMLElement>} */
	// @ts-ignore
	const $overlayHighlights = $container.find('div[data-overlay-highlight]');
	if ($overlayHighlights.length > 0) {
		import('./mpro.overlay-highlight.js').then(({ initOverlayHighlight }) => initOverlayHighlight($overlayHighlights.eq(0)));
	}

	// Tick counter v2
	/** @type {JQuery<HTMLElement>} */
	const $tickCounters = $container.find('div[data-counter]');
	if ($tickCounters.length > 0) {
		import('./tick-counter').then(({ enhanceElements }) => enhanceElements($tickCounters));
	}

	// Input mask plugin
	/** @type {JQuery<HTMLElement>} */
	const $inputMask = $container.find('input[data-maskito],textarea[data-maskito]');
	if ($inputMask.length > 0) {
		import('./input-mask').then(({ enhanceElements }) => enhanceElements($inputMask));
	}
});

export default mpro;
